import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

function authHeader(auth) {
  if (!auth) return {};
  const token = btoa(`${auth.username}:${auth.password}`);
  return { Authorization: `Basic ${token}` };
}

export function apiError(e) {
  return (
    e?.response?.data?.detail ||
    e?.message ||
    "Request failed"
  );
}

// Parent
export const lookupParent = (phone_number) =>
  axios.post(`${API}/parents/lookup`, { phone_number }).then((r) => r.data);

export const createParent = (data) =>
  axios.post(`${API}/parents`, data).then((r) => r.data);

export const addChildToParent = (parentId, child) =>
  axios.post(`${API}/parents/${parentId}/children`, child).then((r) => r.data);

export const editChild = (parentId, childId, payload) =>
  axios.patch(`${API}/parents/${parentId}/children/${childId}`, payload).then((r) => r.data);

export const createCheckin = (parent_id, child_ids) =>
  axios.post(`${API}/visits/checkin`, { parent_id, child_ids }).then((r) => r.data);

export const recordConsent = (parentId, payload) =>
  axios.post(`${API}/parents/${parentId}/consent`, payload).then((r) => r.data);

export const logNoticePresented = (phone_number, version) =>
  axios.post(`${API}/consent/notice-presented`, { phone_number, version }).then((r) => r.data);

// Host
export const hostLogin = (auth) =>
  axios.post(`${API}/host/login`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const createBirthdayRequest = (payload) =>
  axios.post(`${API}/birthday-requests`, payload).then((r) => r.data);

export const createEventManual = (auth, payload) =>
  axios.post(`${API}/admin/events`, payload, { headers: authHeader(auth) }).then((r) => r.data);

export const getEvents = (auth, params = {}) =>
  axios.get(`${API}/admin/events`, { headers: authHeader(auth), params }).then((r) => r.data);

export const updateEvent = (auth, id, patch) =>
  axios.patch(`${API}/admin/events/${id}`, patch, { headers: authHeader(auth) }).then((r) => r.data);

export const deleteEvent = (auth, id) =>
  axios.delete(`${API}/admin/events/${id}`, { headers: authHeader(auth) }).then((r) => r.data);

export const adminLogin = (auth) =>
  axios.post(`${API}/admin/login`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const getPending = (auth) =>
  axios.get(`${API}/host/pending`, { headers: authHeader(auth) }).then((r) => r.data);

export const getActive = (auth) =>
  axios.get(`${API}/host/active`, { headers: authHeader(auth) }).then((r) => r.data);

export const getStats = (auth) =>
  axios.get(`${API}/host/stats`, { headers: authHeader(auth) }).then((r) => r.data);

export const confirmCheckin = (gid, auth, payment) =>
  axios
    .post(`${API}/host/confirm/${gid}`, payment || { skip_payment: false }, {
      headers: authHeader(auth),
    })
    .then((r) => r.data);

export const updatePayment = (gid, auth, payment) =>
  axios
    .post(`${API}/host/payment/${gid}`, payment, { headers: authHeader(auth) })
    .then((r) => r.data);

export const checkoutChild = (vid, auth) =>
  axios.post(`${API}/host/checkout/${vid}`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const checkoutGroup = (gid, auth) =>
  axios.post(`${API}/host/checkout-group/${gid}`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const deletePending = (gid, auth) =>
  axios.delete(`${API}/host/pending/${gid}`, { headers: authHeader(auth) }).then((r) => r.data);

export const refundPayment = (gid, auth, body) =>
  axios.post(`${API}/host/refund/${gid}`, body || {}, { headers: authHeader(auth) }).then((r) => r.data);

export const markNoShow = (gid, auth) =>
  axios.post(`${API}/host/no-show/${gid}`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const collectVisitPayment = (visitId, auth, body) =>
  axios.post(`${API}/host/visit-payment/${visitId}`, body || {}, { headers: authHeader(auth) }).then((r) => r.data);

export const markVisitNoShow = (visitId, auth) =>
  axios.post(`${API}/host/visit-no-show/${visitId}`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const requestPaymentChange = (visitId, auth, body) =>
  axios.post(`${API}/host/payment-change/${visitId}`, body, { headers: authHeader(auth) }).then((r) => r.data);

export const searchParents = (query, auth) =>
  axios.post(`${API}/host/search`, { query }, { headers: authHeader(auth) }).then((r) => r.data);

export const pauseVisit = (vid, auth) =>
  axios.post(`${API}/host/pause/${vid}`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const resumeVisit = (vid, auth) =>
  axios.post(`${API}/host/resume/${vid}`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const getDailyStats = (auth, date) =>
  axios
    .get(`${API}/host/daily-stats`, { headers: authHeader(auth), params: date ? { date } : {} })
    .then((r) => r.data);

// Admin
export const getAdminStats = (auth) =>
  axios.get(`${API}/admin/stats`, { headers: authHeader(auth) }).then((r) => r.data);

export const getPaymentChanges = (auth) =>
  axios.get(`${API}/admin/payment-changes`, { headers: authHeader(auth) }).then((r) => r.data);
export const approvePaymentChange = (auth, id) =>
  axios.post(`${API}/admin/payment-changes/${id}/approve`, {}, { headers: authHeader(auth) }).then((r) => r.data);
export const rejectPaymentChange = (auth, id) =>
  axios.post(`${API}/admin/payment-changes/${id}/reject`, {}, { headers: authHeader(auth) }).then((r) => r.data);

export const getStatsRange = (auth, start, end) =>
  axios
    .get(`${API}/admin/stats-range`, { headers: authHeader(auth), params: { start, end } })
    .then((r) => r.data);

export const getBirthdays = (auth, filter, month, lvStart, lvEnd, eligibleOnly) =>
  axios
    .get(`${API}/admin/birthdays`, {
      headers: authHeader(auth),
      params: {
        filter,
        ...(month ? { month } : {}),
        ...(lvStart ? { last_visit_start: lvStart } : {}),
        ...(lvEnd ? { last_visit_end: lvEnd } : {}),
        ...(eligibleOnly ? { eligible_only: true } : {}),
      },
    })
    .then((r) => r.data);

export const downloadCsv = async (path, auth, params, fallbackName) => {
  const res = await axios.get(`${API}${path}`, {
    headers: authHeader(auth),
    params,
    responseType: "blob",
  });
  if (res.data && res.data.type && res.data.type.includes("application/json")) {
    const text = await res.data.text();
    let detail = "Download failed";
    try { detail = JSON.parse(text).detail || detail; } catch (_) {}
    throw new Error(detail);
  }
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const name = m ? m[1] : fallbackName;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
